import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";

import { makeRequestAuth, uploadRequest } from "../../utils/globals";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import ImageLoader from "../ImageLoader";

class ImageUploadModal extends Component {
  state = {
    showModal: true,
    image: "/admin/img/icons/upload-blue.svg",
    imgUpload: "",
    imgagename: "",
  };

  handleModal = () => {
    this.setState({
      showModal: false,
    });
    this.props.callbackMethod ? this.props.callbackMethod() : null;
  };

  componentWillMount() {
    this.setState(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.uploading != this.state.uploading) {
      this.setState({
        uploading: nextProps.uploading,
      });
    }
    if (nextProps.errorMessage != this.state.errorMessage) {
      this.setState({
        errorMessage: nextProps.errorMessage,
      });
    }
    if (nextProps.msgClass != this.state.msgClass) {
      this.setState({
        msgClass: nextProps.msgClass,
      });
    }
  }

  uploadFile = (event) => {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({
          image: e.target.result,
        });
      };
      reader.readAsDataURL(event.target.files[0]);
      this.setState({
        imgagename: event.target.files[0].name.split(" ").join("_"),
        imgUpload: event.target.files,
      });
    } else {
      NotificationManager.info(
        "Image size should be less than 300Kb",
        "Warning"
      );
    }
  };

  uploadImage = () => {
    this.props.uploadImage(this.state.imgUpload);
  };

  render() {
    const { imageRestriction } = this.state;

    const { uploading } = this.props;

    return (
      <div>
        <Modal isOpen={this.state.showModal} className="message-modal">
          <Row>
            <div className="col-sm-12 text-right pr-4 pt-3">
              <img
                src="/admin/img/svg-icons/cross.svg"
                onClick={() => {
                  this.handleModal();
                }}
              />
            </div>
          </Row>
          <ModalHeader className="m-auto">
            {this.props.header ? this.props.header : "Upload Reward Icon"}
          </ModalHeader>
          <ModalBody>
            <div className="uploadcsvbulk border-default">
              <div className="row p-3">
                <div className="col-12">
                  <img src={this.state.image} className="upload-image" />
                </div>
                <div className="col-12">
                  <input
                    accept=".jpg, .jpeg, .png"
                    className="file d-none"
                    id="contained-button-file"
                    type="file"
                    onChange={this.uploadFile}
                  />
                </div>
                <div className="col-12">
                  {this.state.imgagename ? (
                    <div className="py-2">
                      <span>{this.state.imgagename}</span>
                    </div>
                  ) : null}
                  {this.state.errorMessage != "" ? (
                    <div className="py-2">
                      <span
                        className={
                          this.state.msgClass ? this.state.msgClass : null
                        }
                      >
                        {this.state.errorMessage}
                      </span>
                    </div>
                  ) : null}
                </div>
                <div className="col-12">
                  <label
                    htmlFor="contained-button-file"
                    className=" btn btn-default2 my-2 mb-4"
                  >
                    {" "}
                    Choose Image
                  </label>
                </div>
                {imageRestriction ? (
                  <div className="col-12">
                    <label>{imageRestriction}</label>
                  </div>
                ) : null}
                <div className="col-12"></div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Row>
              <Col xs="6">
                <Button
                  color="secondary medium"
                  onClick={() => {
                    this.handleModal();
                  }}
                >
                  {this.state.cancelbtn ? this.state.cancelbtn : "Cancel"}
                </Button>
              </Col>
              <Col xs="6">
                <Button
                  color="primary medium"
                  onClick={this.uploadImage}
                  disabled={this.state.imgagename == "" || uploading}
                >
                  {uploading ? (
                    <ImageLoader />
                  ) : this.state.btnText ? (
                    this.state.btnText
                  ) : (
                    "Upload"
                  )}
                </Button>
              </Col>
            </Row>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ImageUploadModal;
